"use client";
// https://react-slick.neostack.com/docs/example/multiple-items
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Image from "next/image";
import parse from "html-react-parser";
import { IPageContent } from "@/types/pageContent.types";
import "./BlogsSlider.scss";
import TransitionLink from "@/components/TransitionLink";


export type IHomeViewProps = {
  section: string;
  blogsListingFeaturedData: IPageContent["allInsightsListingPageModels"][0]["blogPage"] ;
};
interface IArrowProps {
  className: string;
  style: React.CSSProperties;
  onClick: () => void;
}

const BlogsSlider: React.FC<IHomeViewProps> = (
  { section, blogsListingFeaturedData }
) => {
  // console.log("-------->>> blogsListingFeaturedData:", blogsListingFeaturedData);

  let rightArrow: { url: string; alt: string }; 
  let leftArrow: { url: string; alt: string }; 

  // // Find the gallery item that contains arrows - search dynamically instead of hardcoded index
  // const galleryItem = blogsListingFeaturedData.find(item => 
  //   'gallery' in item && 
  //   item.gallery.some(g => 'title' in g && typeof g.title === 'string' && g.title.includes("Arrow"))
  // );
  
  // const arrows = galleryItem && 'gallery' in galleryItem 
  //   ? galleryItem.gallery.filter((arrow): arrow is { 
  //       title: string; 
  //       url: string; 
  //       alt: string 
  //     } => {
  //       return 'title' in arrow && typeof arrow.title === 'string' && arrow.title.includes("Arrow");
  //     })
  //   : [];

  // const CustomPrevArrow = ( props: IArrowProps ) => {
  //   const { className, style, onClick } = props;
  //   if (!arrows || arrows.length === 0) return null;
  //   return (
  //       <Image
  //         src={arrows[0].url}
  //         alt="Previous"
  //         className={className || ""}
  //         style={{ ...style, left: "10px", zIndex: 10, width: "40px", height: "40px" }}
  //         onClick={onClick}
  //         width={100}
  //         height={100}
  //       />
  //   );
  // };
  
  // const CustomNextArrow = ( props: IArrowProps ) => {
  //   const { className, style, onClick } = props;
  //   if (!arrows || arrows.length === 0) return null;
  //   return (
  //       <Image
  //         src={arrows[0].url}
  //         alt="Next"
  //         className={className || ""}
  //         style={{ ...style, right: "10px", zIndex: 10, width: "40px", height: "40px" }}
  //         onClick={onClick}
  //         width={100}
  //         height={100}
  //       />
  //   );
  // };

  // const settings = {
  //   className: "center",
  //   centerMode: true,
  //   infinite: true,
  //   centerPadding: "0px",
  //   slidesToShow: 6,
  //   speed: 500,
  //   // nextArrow: <CustomNextArrow className="" style={{}} onClick={() => {}} />,
  //   // prevArrow: <CustomPrevArrow className="" style={{}} onClick={() => {}} />,
  //   // responsive: [
  //   //   {
  //   //     breakpoint: 1024,
  //   //     settings: {
  //   //       centerPadding: "0px",
  //   //       slidesToShow: 3,
  //   //       slidesToScroll: 1,
  //   //       // infinite: true,
  //   //       // dots: true
  //   //     }
  //   //   },
  //   //   {
  //   //     breakpoint: 430,
  //   //     settings: {
  //   //       centerPadding: "0px",
  //   //       slidesToShow: 1,
  //   //       slidesToScroll: 1,
  //   //       // infinite: true,
  //   //       // dots: true
  //   //     }
  //   //   }
  //   // ]
  // };

  const settings = {
    className: "center",
    centerMode: false,
    infinite: true,
    centerPadding: "0px",
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    dots: false,
    arrows: true,
    responsive: []
  };

  // console.log("blogsListingFeaturedData ", blogsListingFeaturedData)

  return (
    <div className="blogsSlider">
      <Slider {...settings}>
        {blogsListingFeaturedData
          .map((card, index) => (
            <div key={index} className="card">

              <div className="copyContainer">
                <span>{parse(card.overline)}</span>
                <h2>{parse(card.heading)}</h2>
                <button>
                  <TransitionLink href={`${card.blogLink}`}>
                    <p>Read More</p>
                    <span className="sr-only">about {card.heading}</span>
                  </TransitionLink>
                </button>
              </div>

              <div className="imgContainer">
                <Image
                  src={card.blogArticleImage.url}
                  alt={card.blogArticleImage.alt || ""}
                  fill
                  style={{ objectFit: 'cover' }}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              </div>

            </div>
          ))}
      </Slider>
    </div>
  );
}

export default BlogsSlider;
